import { Routes } from '@angular/router';
import { permissionGuard } from '@core/auth/permission.guard';
import { APP_PERMISSIONS } from '@core/constants/permission.constants';
import { APP_ROUTES } from '@core/constants/routes.constants';

// `new` is listed before the `:id` route so it is not read as an id.
export const assessmentsRoutes: Routes = [
  {
    title: 'pagesTitles.assessmentCreate',
    path: APP_ROUTES.ASSESSMENTS_NEW,
    canActivate: [permissionGuard(APP_PERMISSIONS.AssessmentsCreate)],
    loadComponent: () => import('./pages/create-assessment').then((m) => m.CreateAssessment),
  },
  {
    title: 'pagesTitles.assessmentDetail',
    path: APP_ROUTES.ASSESSMENTS_DETAIL,
    canActivate: [permissionGuard(APP_PERMISSIONS.AssessmentsRead)],
    loadComponent: () => import('./pages/show-assessment').then((m) => m.ShowAssessment),
  },
  {
    title: 'pagesTitles.assessmentBaseline',
    path: APP_ROUTES.ASSESSMENTS_BASELINE,
    canActivate: [permissionGuard(APP_PERMISSIONS.HazardBaselineInputsRead)],
    loadComponent: () => import('./pages/assessment-baseline').then((m) => m.AssessmentBaseline),
  },
];
